import { NanoProgress } from 'foundations-components/transitional/components/NanoProgress';
import { memo } from 'react';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { FileAttachment } from 'foundations-components/transitional/components/FileAttachment';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const FileAttachmentWithProgress = ({
  fileName,
  progress
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlock: "100",
    children: /*#__PURE__*/_jsx(FileAttachment, {
      fileName: /*#__PURE__*/_jsx(TruncateString, {
        children: fileName
      }),
      size: "small",
      "data-test-id": "file-attachment-with-progress",
      children: /*#__PURE__*/_jsx(NanoProgress, {
        value: progress,
        boxShadow: false
      })
    })
  });
};
export default /*#__PURE__*/memo(FileAttachmentWithProgress);